export const vegetablePancakes = {
  id: "vegetablePancakes",
  link: "/#/recipes/recipes/vegetablePancakes",
  name: "Vegetable Pancakes",
  cuisine: "Tashikki",
  summary: "Savory zucchini pancakes flavored with preserved lemon",
  inspiration: "Okonomiyaki",
  quantity: "4 8-9 inch pancakes",
  time: "30 minutes",
  notes:
    "When I read about salty vegetable pancakes, I immediately thought of okonomiyaki (japanese streetfood - cabbage pancakes with all sorts of sauces). I started with that idea, then changed the ingredients and flavors to inherit more from North African influences to match Tashikk better. The preserved lemons are the star of this dish - look for them at a global goods grocery store or online. I didn't end up topping with a sauce, as I liked the pancakes as is and there's no indication in the books that they were served with sauce, but feel free to experiment with toppings! If you find a sauce (or combination of sauces) that you really like, let me know in the feedback form!",
  quotes:
    "One of the pancakes was salty, with chopped-up vegetables. (Edgedancer ch 8)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/vegetable-pancakes-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "rice",
          display: "1 cup rice flour"
        },
        {
          item: "salt",
          display: "1 tsp salt"
        },
        {
          item: "cumin",
          display: "1/2 tsp ground cumin"
        },
        {
          item: "eggs",
          display: "3 eggs"
        },
        {
          item: "dashi",
          display: "1/2 cup dashi"
        },
        {
          item: "summerSquash",
          display: "6 cups shredded zucchini (about 3 medium)"
        },
        {
          item: "preservedLemon",
          display: "1 1/2 small preserved lemons"
        },
        {
          item: "vegetableOil",
          display: "vegetable oil for frying"
        }
      ]
    }
  ],
  steps: [
    "Combine rice flour, salt and cumin in a bowl. Briefly beat the eggs and add them to the mixture along with the dashi. Mix until combined. You can make dashi from dried bonito stock granules (hon dashi) according to the directions on the package.",
    "Take the preserved lemons and scoop out the pulp and discard, preserving the peels. Mince the peels to get 1/4 cup peel. You can shred the zucchini using the grater disk on a food processor or a hand-held grater. Add the minced lemon peel and the shredded zucchini to the mixture. Mix until combined.",
    "Heat 1 tbsp vegetable oil in a 8-9 inch frying pan over medium high heat. Toss the batter a bit to distribute any liquids at the bottom, then scoop 1 cup batter out and add it to the pan. Spread out the batter to fill the pan in an even layer. Cook until the bottom is browned about 2-3 minutes, then flip. The easiest way to flip the pancake is to slide the pancake out of the pan onto a plate, then put the pan upside down over the pancake on the plate, and flip both the plate and pan quickly to drop the pancake onto the pan, uncooked side down. Cook until the other side is browned, about 1-2 minutes, then remove from the pan, add another 1/2 tbsp oil, and do it all again. (Toss the batter, add 1 cup batter to pan, etc.) Repeat until you've used all the batter."
  ]
}
